// extracted by mini-css-extract-plugin
export default {"section":"CzWSuN","header":"FfjHRb","price":"pVcM0M"};